import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';

import { input } from '$gbusiness/helpers';
import { FormSection } from '$gcomponents/reusables';
import { Button, Text } from '$gcomponents/primitives';

import { AppForm } from '$styles/general';
import MuiModal from '$gcomponents/reusables/modal/material';
import intl from '$intl';
import { factoryActions } from '$fbusiness/redux/factory';
import { configs } from '$configs';
import BankModel from '$fbusiness/models/bank';
import { BANK_FORM } from './bankForm';
import StoreModel from '$fbusiness/models/store';
import { storeActions } from '$fbusiness/redux/store';

interface BankModalProps {
  bank: BankModel;
  store: StoreModel;
  onClose: Function;
}

const BankModal: React.FC<BankModalProps> = ({ bank, store, onClose }) => {
  const dispatch = useDispatch();
  const formRef = useRef<any>();

  if (!bank) return null;
  const { id, ...initialValues } = bank;

  const onSubmit = (values) => {
    const param = {
      ...values,
      storeId: store?.id || null,
    };
    dispatch(factoryActions.saveObj(id || 0, param, configs.api.bank)).then(() => {
      dispatch(storeActions.fetchStore(store.id));
      onClose();
    });
  };

  const validateForm = (values) => input.validateError(BANK_FORM, values);

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize={true}
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={(values) => {
        onSubmit(values);
      }}>
      {(formik) => (
        <MuiModal
          open={!!bank}
          width="400px"
          onClose={() => onClose()}
          title={intl('SCREEN.STORES.BANK.TITLE')}
          footer={
            <Button fullWidth onClick={formik.handleSubmit} disabled={!(formik.isValid && formik.dirty)}>
              <Text k="BUTTON.SAVE" />
            </Button>
          }>
          <div className="content">
            <AppForm>
              <FormSection FORM={BANK_FORM} formik={formik} />
            </AppForm>
          </div>
        </MuiModal>
      )}
    </Formik>
  );
};

export default BankModal;
